const ja = {
	certification: {
		verification: '実名情報',
		updateHistory: '変更履歴',
		certificateRequired: '証明書期限リマインダー',
		changeIdentites: '法人、株主、受益者の変更',
		changePerson: '法人、株主、受益者の変更',
		completeIdentityVerification: '本人確認（KYC）情報の入力',
		verificationTips: '関連する規制機関の要件に従い、アカウントのセキュリティを確保するために、PingPong はユーザーの実際の身元情報を収集し、それを確認する必要があります。',
		verificationTips2nd: 'PingPong は、お客様が提供する実名情報を極秘に保つことを約束します。',
		imgUploadTips: '画像アップロードの要件: アップロードしてください',
		imgUploadTips2nd: '元の写真または元の文書のカラー スキャン。文書の四隅が完全かつ鮮明であることを確認します。',
		imgUploadTips3rd: '無関係な透かし、白黒のコピー、スキャン、スクリーンショットは受け付けられません。最大サイズは 10M を超えることはできず、形式は JPG、JPEG、PNG、BMP、PDF に制限されます。',
		imgExample: 'サンプル画像を見る',
		auditReport: '監査報告書',
		writeCompany: '会社情報を入力してください',
		writeLegal: '法人情報を入力してください',
		writeDirector: '株主情報を入力してください',
		writeDirector2: 'ディレクター情報を入力してください',
		writeBeneficiary: '受取人情報を入力してください',
		uploadDesc: '承認時間を短縮するために、写真情報が明確に見えるようにしてください。'
	},
	review: {
		messageTip: 'あなたの本名情報は審査中です。しばらくお待ちください。',
		messageReSubmit: '送信した実名認証は、データが欠落しているか情報が間違っているため、審査に失敗しました。再提出してください。',
		approved: 'あなたの本名情報は審査され、承認されました',
		uneligible: '残念ながら、現在あなたには資格がありません。'
	},
	add: {
		applicantsIdentity: '法人情報 申請者の身元',
		informationofApplicant: '法人情報をご入力ください',
		addApplicantIdentity: '法定代表者を追加',
		shareholderIdentity: '株主情報 取締役の略歴',
		shareholderIdentity2: '役員の本人確認情報',
		informationofshareholder: '会社の株主全員の情報を入力してください',
		informationofshareholder2: '会社の取締役全員の情報を入力してください',
		addashareholder: '株主を追加する',
		addashareholder2: '役員を追加',
		BeneficiaryIdentity: '実質的支配者の本人確認情報',
		informationofBeneficiary: '株式の 25% 以上を保有する自然人株主の情報を入力してください',
		informationofBeneficiary2: '株式の 25% 以上を保有する自然人の取締役の情報を入力してください',
		addabeneficiary: '実質的支配者を追加',
		goBack: '前のステップに戻る',
		saveAndNext: '保存して次のステップに進みます',
		submitwebsite: 'ウェブサイトを送信して追加する',
		submitVerification: '実名情報を送信する',
		save: '一時保存',
		deleted: '正常に削除されました',
		deleteFailed: '削除に失敗しました',
		tryAgain: 'もう一度試してください',
		pic: '画像を追加',
		uploadFile: 'ファイルアップロード',
		reupload: '再アップロード',
		uploadSuccess: 'ファイルが正常にアップロードされました',
		notice: '確認',
		uploadFileNotice: 'アップロードするファイルのサイズは以下を超えることはできません',
		imgLimited: '画像は JPG、JPEG、PNG、BMP 形式である必要があります',
		pictureFormatError: 'ファイル形式エラー',
		picUploadSuccess: 'ファイルが正常にアップロードされました',
		uploadMethods: 'アップロード方法を選択してください',
		PleaseUploadInformation: '情報をアップロードしてください',
		uploadFailed: '画像のアップロードに失敗しました。もう一度アップロードしてください',
		uploadLimited: '画像は JPG、JPEG、PNG、BMP 形式である必要があります',
		uploadagain: '元の画像を削除して再アップロードしてください',
		uploadPic1st: 'アップロードのみ可能',
		uploadPic2nd: '画像ファイル',
		uploadFileImgAgain: '元のファイルを削除して、再度アップロードしてください',
		uploadFileImg1st: 'アップロードのみ可能',
		uploadFileImg2nd: 'ファイル',
		reupload2: '画像のアップロードに失敗しました',
		choose: '選択'
	},
	company: {
		businessType: '法人種別',
		soleProprietorship: '個人事業主',
		companyLimited: '有限会社',
		jointVentureCompany: '合弁事業',
		listedCompany: '上場企業',
		corporationOrganization: '会社・法人・団体',
		others: 'その他',
		businessInformation: '会社情報',
		businessLocation: '登記国 / 地域',
		select: '選択してください',
		companyNameEnglish: '会社名（英語）',
		businessAddressEnglish: '詳細住所（英語）',
		hkBusinessAddressEnglish: '会社の英語住所',
		businessIdentityNumber: '法人番号',
		phBusinessIdentityNumber: '法人番号',
		taxCardNumber: '法人税番号',
		taxCardImg: 'インドネシアの納税カード（イメージ）',
		businessEstablishedDate: '設立年月日',
		businessExpirationDate: '有効期限',
		license1: 'ビジネスライセンスの画像 - スキャンしたコピー',
		license2: '営業許可証の画像 - コピー',
		license3: '法務人権省認定',
		companyCharter: '定款',
		bankAccountInformation: '同名義の銀行口座証明書または預金口座情報',
		picture: '画像ファイル',
		EXCEL: 'EXCELファイル',
		officePhotos: 'オフィス・店舗写真',
		tokenofficePhotos: '店名やロゴが反映できる、店番号、フロントデスク、従業員や消費者との風景の写真など、実際の事業所/店舗の写真を提供してください。',
		logo: '商標ロゴ',
		logoTip: '最大ファイルサイズは10MB、サイズは720px*200pxです。 PNG 形式を提供するようにしてください。',
		addressProof: '住所証明',
		billOrcontract: '会社のオフィス賃貸契約書または会社の公共料金請求書 (公共料金請求書にはオフィスの住所を記入してください)',
		hkBillOrcontract: 'オフィスの賃貸借契約書',
		selectTheDate: '日付を選択してください',
		longTermEffective: '長期有効',
		partnership: 'パートナー証明書',
		structure: '株式構成図',
		hkCompanyName: '会社名',
		// HK 新增
		hkBusinessAddress: '会社住所',
		// HK 新增
		hkRegistrationCertificate: '会社設立証明書',
		// HK 新增
		hkRegistrationCertificateNo: '登録証番号',
		// HK 新增
		hkCompanyEstablishedDate: '会社登録時期',
		// HK 新增
		hkBusinessLicenceCertNo: '事業者登録番号（上8桁）',
		// HK 新增
		hkBusinessLicenceCertFile: '事業者登録証明書',
		// HK 新增
		hkBusinessEstablishedDate: 'ビジネス登録証明書の発効日',
		hkBusinessExpirationDate: '事業者登録証明書の有効期限',
		hkAnnualReport: '設立フォームまたは年次申告書',
		// HK 新增,
		hkAnnualReportTips: 'NNC1（法人設立届）は設立後1年以内に提出可能ですが、NAR1（年次申告書）は設立から1年以上経過した場合に提出する必要があります。',
		// HK 新增
		phTaxCardNumber: '法人税番号',
		// PH新增
		phTaxCardImg: '法人税カード証明書（イメージ）',
		// PH新增
		companyRegisterCertificate: '会社設立証明書',
		// 公司注册证明
		generalInfoTable: '一般情報シート',
		// 公司基本信息表
		specialIndustryLicense: '特別業種許可',
		// 特殊行业许可证
		subMerchantInfoTable: 'サブマーチャント情報テーブル',
		// 子商户信息表
		registeredCapitalCertificate: '登録資本金証明書'
	},
	person: {
		title1: '身分証明情報',
		title2: '基本情報',
		title3: '連絡先',
		title4: '居住地情報',
		nationality: '国籍',
		indonesiaIdPicture: 'インドネシアの国民証明写真',
		vietnamIdPicture: 'ベトナム国民IDカードの写真',
		malaysiaIdPicture: 'マレーシアの国民証明写真',
		phPicture: 'フィリピンの国民証明写真',
		thPicture: 'タイの国民証明写真',
		jpPicture: '身分証明書画像',
		krPicture: '韓国の国民証明写真',
		sgPicture: 'シンガポールの国民証明写真',
		passport: 'パスポート',
		iDIssueDate: '有効期間（開始）',
		iDExpirationDate: '有効期限',
		birthDate: '生年月日',
		enFirstName: '名（英語）',
		enLastName: '姓 (英語)',
		originFirstName: '名（母国語）',
		originLastName: '姓 (母国語)',
		birthCountry: '出生国',
		phone: '電話番号',
		email: 'メールアドレス',
		postcode: '郵便番号',
		country: '国 / 地域',
		state: '都道府県 / 州',
		city: '市区町村',
		region: '区 / 地域',
		address: '詳細住所（英語）',
		residentialAddress: '居住地の住所（母国語）',
		idCardNumber: 'ID番号',
		taxCardNumber: '納税者番号',
		idCardPicture: '税金カードの写真',
		sharesProportion: '持株比率',
		picTip: 'パスポート以外の身分証明書をアップロードする場合は、最初に表面の写真をアップロードし、次に裏面の写真をアップロードしてください。',
		authorisedLetterFileName: '代理人の承認文書',
		businessTitle: 'エージェントの役職',
		addressFile: '住所証明',
		ubo: 'UBOお申込みフォーム',
		uboDownloadDesc: '「受益者申請書」に必要事項を記入・署名・捺印の上、スキャンしてアップロードしてください。',
		uboDownloadTitle: '「受給者申請書」をダウンロード'
	},
	rules: {
		required: '必須項目です',
		sharesRule: '0 以上のシェア率を入力してください',
		bankAccountInfo: '銀行口座開設ライセンスまたは基本的な預金口座情報をアップロードしてください',
		proofFlow: '取引証明書をアップロードしてください',
		registeredCompany: '会社が登録されている国または地域を選択してください',
		companyChineseName: '会社の中国語名を入力してください',
		companyEnglishName: '会社の英語名を入力してください',
		chooseCity: '都市を選択してください',
		companyChineseAddress: '会社の中国の住所を入力してください',
		companyEnglishAddress: '会社の英語の住所を入力してください',
		companyEnglishCity: '英語の都市を入力してください',
		companyEnglishAddressValid: '有効な情報を入力してください',
		postCode: '郵便番号を入力してください',
		postCodeValid: '英語と数字のみが使用できます',
		businessIdentityNumber: 'ビジネスライセンス番号を入力してください',
		bussinessEstablishedDate: 'ビジネスライセンスの発効日を選択してください',
		companyExpiredDate: '会社登記証明書の有効期限を選択してください',
		governmentBussinessCertification: '営業許可証の写真をアップロードしてください',
		HKgovernmentBussinessCertification: 'ビジネス登録証明書の写真をアップロードしてください',
		governmentBussinessCertification2: '会社登記証明書の写真をアップロードしてください',
		applicationForm: '販売者申請フォームをアップロードしてください',
		websiteCertificate: 'ウェブサイトのドメイン名登録証明書をアップロードしてください',
		billOrlease: '会社のオフィス賃貸契約書または会社の公共料金請求書をアップロードしてください',
		addedUser: '登録済みの担当者を選択',
		IDType: '文書の種類',
		IDCardNumber: 'ID番号',
		IDNumber: 'ID番号',
		IDIssueDate: '有効期間（開始）',
		IDExpirationDate: '有効期限',
		legal: '法人',
		director: '株主',
		director2: '監督の名前',
		beneficial: '受益者',
		legalIDCardUpdate: '法人身分証明書の更新',
		directorIDCardUpdate: '株主本人確認書類の更新',
		directorIDCardUpdate2: 'ディレクターの身分証明書の更新',
		beneficialIDCardUpdate: '受取人IDの更新',
		legalInfoUpdate: '法人情報更新',
		directorInfoUpdate: '株主情報の更新',
		directorInfoUpdate2: '役員情報更新',
		beneficialInfoUpdate: '受取人情報更新',
		companyUpdate: '会社証明書の更新',
		legalChange: '法人を変更する',
		directorChange: '株主変更',
		beneficialChange: '受取人の変更',
		fullName: '名前',
		fullNameEN: '英語名',
		firstNameEN: '英語での名前',
		lastNameEN: '姓 英語',
		fullShareholderName: '株主名',
		fullShareholderName2: '監督の名前',
		fullShareholderNameEN: '株主名 英語',
		firstShareholderNameEN: '株主名 英語',
		lastShareholderNameEN: '株主の姓（英語）',
		fullShareholderNameEN2: '監督名 英語',
		firstShareholderNameEN2: '取締役名 英語',
		lastShareholderNameEN2: 'ディレクターの姓（英語）',
		fullBeneficiaryName: '受取人名',
		fullBeneficiaryNameEN: '受取人名 英語',
		firstBeneficiaryNameEN: '受取人名 英語',
		lastBeneficiaryNameEN: '受取人の姓 英語',
		halfName: '名前',
		sameInId: '証明書のピンインと同じ',
		phoneNumber: '電話番号',
		emailAddress: 'メールアドレス',
		email: 'メールの形式が正しくありません',
		DOB: '生年月日',
		nationality: '住宅街',
		addressChinese: '中国の居住住所',
		ConsistentWithid: '証明書の住所と一致するようにしてください',
		addressEnglish: '英語の住居住所',
		save: '保存',
		submit: '保存',
		cancel: 'キャンセル',
		InputIDExpirationDate: '証明書の有効期限を選択してください',
		saveSuccess: '正常に保存されました',
		saveFailed: '保存に失敗しました',
		reSave: 'もう一度保存してください',
		selectIDType: '書類の種類を選択してください',
		uploadIDpic: '証明写真をアップロードしてください',
		uploadIDbackPic: '身分証明書の裏面の写真をアップロードしてください',
		inputIDNumber: 'ID番号を入力してください',
		inputIDExpireDate: '証明書の発効日を選択してください',
		pleaseEnter: '入力してください',
		realNameCn: '中国語名を入力してください',
		realNameEn: '英語名を入力してください',
		realNameEnRule: '英字を入力してください。スペースは使用できません',
		enNameRule: '英文字を入力してください',
		enterPhoneNumber: '連絡先番号を入力してください',
		enterEmail: 'メールアドレスを入力してください',
		selectDOB: '生年月日を選択してください',
		errorDOB: '18 歳以上である必要があります',
		selectNation: '居住国を選択してください',
		enterAddressChinese: '中国の居住住所を入力してください',
		enterAddressEnglish: '英語の居住住所を入力してください',
		selectBussinessType: '会社の種類を選択してください',
		chinaId: '本土のIDカード',
		hongkongId: '香港のIDカード',
		passport: 'パスポート',
		permit: '本土旅行券',
		others: 'その他',
		companyCharter: '定款',
		otherstuff: 'その他の補足資料',
		companyCharterWarn: '会社定款をアップロードしてください',
		companyType: '会社の種類を選択してください',
		selectState: '州を選択してください',
		inputCity: '都市名を入力してください',
		selectContinent: '地域を選択',
		error1: '発効日は有効期限より後の日付にすることはできません',
		error2: '有効期限を発効日よりも前にすることはできません',
		error3: '何も操作しないと送信できません'
	},
	approveInfo: {
		menuList: ['会社情報', '法人情報', '株主情報', '役員情報', '実質的支配者情報', '変更履歴'],
		edit: '編集{name}',
		add: '{name} を追加',
		save: '保存してレビューのために送信する',
		saveWarning: '何も操作しないと送信できません',
		saveError: '少なくとも 1 つの {name} があります',
		cancel: '変更をキャンセルする',
		legal: {
			desc: '現在の法人は、'
		},
		director: {
			desc: '現在の株主は、',
			desc2: '現在の取締役は、'
		},
		beneficial: {
			desc: '現在の受取人は、'
		}
	},
	update: {
		time: '提出時間',
		type: '種類の変更',
		status: 'ステータス',
		operator: '担当者',
		modify: '改訂',
		improved: '改善すべき内容',
		go: 'に行く',
		forDetail: '書類の審査状況を確認する',
		edit: '埋める'
	},
	status: {
		pending: '審査中',
		modify: '修正予定',
		passed: '審査通過'
	},
	success: {
		title: '実名情報が送信されました。引き続き店舗を追加してください',
		tips: ['実名認証は審査のために提出されました。審査結果は5～7営業日以内にご連絡いたします。気長にお待ちください。', 'ご質問がある場合は、専任のアカウント マネージャーにお問い合わせいただくか、カスタマー サービス (400-996-9666) までお電話ください。'],
		btn: '店舗追加に進む'
	},
	changePerson: {
		toHistory: '送信後にレビューの進行状況を確認する必要がある場合は、<a href="/aq/offlineKyc?type=updateHistory" style="color:#1fa0e8;display:inline">[変更記録]</a> で確認してください。',
		changeTo: 'オブジェクトの変更',
		addLegalTip: '提出して承認されると、その法人は自動的に元の法人に置き換わります。',
		addLegal: '新しい法人を追加する',
		existDirector: '既存株主（削除可能、編集不可）',
		addDirectorTip: '新しい株主を追加する',
		addDirector: '株主を追加する',
		existBeneficial: '既存の受益者 (削除可能、編集不可)',
		addBeneficialTip: '新しい受益者を追加するには、株式の 25% 以上を保有する自然人株主の情報を入力してください。',
		addBeneficial: '実質的支配者を追加'
	},
	example: {
		checkImageExamples: '画像例',
		uploadTip: '画像をアップロードするための要件: アップロードする情報画像のテキストがはっきりと見えること、最大サイズが 10M を超えないこと、形式が JPG、JPEG、PNG、BMP、PDF に制限されていることを確認してください。',
		IDCardExample: 'IDカードの例',
		businessLicense: '営業許可',
		frontofIDCard: '身分証明書の顔写真',
		backofIDCard: 'IDカードバッジの写真',
		businessIdentity: '営業許可証',
		hongkongId: '香港のIDカード',
		additionalInformation: '追加情報',
		provideInfo: 'あなたの会社をより深く理解できるよう、あなたの会社に関連する追加の高品質な資料を提供していただけます。取締役の住所証明、IRS EIN 証明書、個人 SSN などの情報。',
		uploadMethod: 'アップロード方法',
		passport: 'パスポートのホームページ',
		travelPermit: '本土トラベルパスの写真',
		otherPhoto: 'その他の写真'
	}
}
export default ja
